export class UserGioLocation {
  userIP = '';
  latitude;
  longitude;
  IsOrigin;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}





// WEBPACK FOOTER //
// ./src/app/models/user/usergioLocation.ts